import React, { Component } from 'react';
import { toastifyConfiguration } from './functions/toastifyConfiguration';
import { userRoles } from 'util/appConstants';
import { AppContextProvider } from './components/AppContextProvider/AppContextProvider';
import BrowserWarningModal from './components/Modals/browserWarningModal';
import CookieModal from './components/Modals/cookieModal';
import { getCookie } from './functions/getCookie';
import { getConfig } from './functions/getConfig';
import { connect } from 'react-redux';
import * as actions from './global/actions/authActions';
import PrimusHandler from './api/primusHandler';
import './App.css';

class App extends Component {
  state = {
    cookieConsentLevel: getCookie('cookieConsentLevel'),
  };

  async componentDidMount() {
    //logs out the user and resets the url if the logout params is passed (only used when logging out in angularjs)
    if (window.location.search.substr(1) === 'logout=true') {
      this.props.clearAuthState();
      localStorage.clear();
      window.history.replaceState(null, null, window.location.pathname);
    }
    await this.props.initialize();
    if (getCookie('cookieConsentLevel')) {
      this.setState({
        cookieConsentLevel: getCookie('cookieConsentLevel'),
      });
    } else {
      window.builderNoTrack = true;
    }

    if (
      this.props.token &&
      this.props.role !== userRoles.CANDIDATE &&
      this.props.pathname === '/' &&
      this.props.searchQuery !== '?logout=true' &&
      this.props.searchQuery !== '?no-redirect=true'
    )
      window.location.href = `${getConfig().REDIRECTION_URL}/dashboard`;

    if (window.location.search.substring(1, 2) === 'c') {
      let campaignSource = window.location.search.substring(3, window.location.search.length);
      document.cookie = `campaignSource=${campaignSource}; Domain=${
        getConfig().COOKIE
      }; Max-Age=2592000; Path=/; SameSite=Lax`;
    }
  }

  componentDidUpdate() {
    if (this.props.isInitialized && !this.props.authLoading && !this.props.authTwoFactor) {
      this.props.verifyAuthState(this.props.token);
    }
  }

  acceptCookie(level) {
    document.cookie = `cookieConsentLevel=${level}; Domain=${
      getConfig().COOKIE
    }; Max-Age=2147483647; Path=/; SameSite=Lax`;
    this.setState({
      cookieConsentLevel: true,
    });
    window.builderNoTrack = false;
    if (level === 'all') {
      this.setupGoogleAnalytics();
    }
  }

  setupFacebookPixel() {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) {
        return;
      }
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;

      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '2675701892562186');
  }

  setupGoogleAnalytics() {
    // Google analytics tracking initialization
    (function (i, s, o, g, r, a, m) {
      i.GoogleAnalyticsObject = r;
      i[r] =
        i[r] ||
        function () {
          (i[r].q = i[r].q || []).push(arguments);
        };
      i[r].l = 1 * new Date();
      a = s.createElement(o);
      m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
    window.ga('create', 'UA-106462151-1', { siteSpeedSampleRate: 100 });
    // Override sendHitTask to avoid analytics from dev environment
    if (window.location.hostname !== 'futureskill.com' && window.location.hostname !== 'challenge.futureskill.com') {
      window.ga('set', 'sendHitTask', function (model) {
        // Enable console log when debugging google analytics
        // console.log(model.get('hitPayload'));
      });
    }
    window.ga('send', 'pageview');
  }

  render() {
    if (this.state.cookieConsentLevel === 'all') {
      this.setupGoogleAnalytics();
      this.setupFacebookPixel();
    }
    return (
      <AppContextProvider>
        <div className="mainBody">
          {<BrowserWarningModal />}
          {!this.state.cookieConsentLevel && <CookieModal acceptFunction={(value) => this.acceptCookie(value)} />}
          {toastifyConfiguration()}
          {this.props.children}
          <PrimusHandler {...this.props} />
        </div>
      </AppContextProvider>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initialize: () => dispatch(actions.initialize()),
    verifyAuthState: (token) => dispatch(actions.verifyAuthState(token)),
    logout: () => dispatch(actions.logout()),
    clearAuthState: () => dispatch(actions.clearAuthState()),
  };
};

const mapStateToProps = (state) => ({
  pathname: state.router.location.pathname,
  searchQuery: state.router.location.search,
  role: state.auth.userRole,
  token: state.auth.token,
  isInitialized: state.auth.isInitialized,
  authLoading: state.auth.authLoading,
  authTwoFactor: state.auth.authTwoFactor,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
